import React from 'react'
import Head from 'next/head'
import renderLDJSON from './LDJSON'
import { PageMetaData } from 'types/metadata'

type Props = {
  pageMetaData?: PageMetaData
  pageTitle?: string
  ogPageTitle?: string
}

const MetaData = ({ pageMetaData, pageTitle }: Props) => {
  const { description, twitter, product, preloadImages, robots, schema } = pageMetaData || {}
  const {
    product: productSchema,
    breadcrumb: breadcrumbSchema,
    website: websiteSchema,
    organization: organizationSchema,
    itemList: itemListSchema,
  } = schema || {}

  return (
    <Head>
      {pageTitle && <title key='title'>{pageTitle}</title>}


      {description && description !== 'ignore' && (
        <meta name='description' key='description' content={description} />
      )}

      {typeof robots === 'boolean' && (
        <meta
          name='robots'
          key='robots'
          content={
            robots
              ? 'max-image-preview:large, noai, noimageai'
              : 'noindex, nofollow, max-image-preview:large, noai, noimageai'
          }
        />
      )}

      {twitter && (
        <>
          {twitter.card && <meta key='twitter-card' name='twitter:card' content={twitter.card} />}
          {twitter.title && (
            <meta key='twitter-title' name='twitter:title' content={twitter.title} />
          )}
          {twitter.description && (
            <meta
              key='twitter-description'
              name='twitter:description'
              content={twitter.description}
            />
          )}
          {twitter.image && (
            <meta key='twitter-image' name='twitter:image' content={twitter.image} />
          )}
          {twitter.site && <meta key='twitter-site' name='twitter:site' content={twitter.site} />}
        </>
      )}

      {product?.price && (
        <>
          {product.price.currency && (
            <meta
              key='product-price-currency'
              property='product:price:currency'
              content={product.price.currency}
            />
          )}
          {product.price.amount !== undefined && (
            <meta
              key='product-price-amount'
              property='product:price:amount'
              content={String(product.price.amount)}
            />
          )}
        </>
      )}

      {(preloadImages || []).map((image, index) => (
        <link
          key={`preload-image-${index}`}
          rel='preload'
          fetchPriority='high'
          as='image'
          href={image}
        />
      ))}

      {organizationSchema && renderLDJSON(organizationSchema, 'ld-organization')}
      {websiteSchema && renderLDJSON(websiteSchema, 'ld-website')}
      {breadcrumbSchema && renderLDJSON(breadcrumbSchema, 'ld-breadcrumb')}
      {productSchema && renderLDJSON(productSchema, 'ld-product')}
      {itemListSchema && renderLDJSON(itemListSchema, 'ld-itemlist')}
    </Head>
  )
}

export default MetaData
